import React, {PropTypes} from 'react';
import classNames from 'classnames';

const EntryWithRosterReadOnly = ({
  teamName,
  state,
  country,
  rosterPositions,
  pairCode,
  groupCode
}) => (
  <div className="list-group">
    <div className="list-group-item-labeled">
      <div className="list-group-item-labeled-child"
        style={{width: 250}}>
        <span>{'Team Name'}</span>
        <span>{teamName || '-'}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 150}}>
        <span>{'Country'}</span>
        <span>{country || '-'}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 200}}>
        <span>{'State'}</span>
        <span>{state || '-'}</span>
      </div>      
      <div className="list-group-item-labeled-child"
        style={{width: 150}}>
        <span>{'Group Code'}</span>
        <span>{groupCode || '-'}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{width: 150}}>
        <span>{'Companion Code'}</span>
        <span>{pairCode || '-'}</span>
      </div>
    </div>
    <div className="contact-card-wrapper">
      {rosterPositions.map((position, index) => (
        <div className="contact-card"
          key={index}>
          <div className="contact-card-info-wrapper">
            <div>
              <div className={classNames(
                  'contact-card-avatar',
                  {'empty': !position.usbcId}
                )}>{index + 1}
              </div>
            </div>
            {position.usbcId
              ? <div className="contact-card-info">
                  <div className="contact-card-title">
                    <div>{position.firstName} {position.lastName} {position.usbcId ? `(${position.usbcId})` : ''}</div>
                  </div>
                  {position.email
                    ? <a href={`mailto:${position.email || ''}`}><i className="fa fa-envelope" />{` `}{position.email}</a>
                    : null
                  }
                  <div>{`${position.average || 0} (Avg)`}</div>
                  {position.isProfessional
                    ? <div>{`Pro Bowler`}</div>
                    : null
                  }
                </div>
              : <div className="contact-card-info">{'Empty roster position'}</div>
            }
          </div>
        </div>
      ))}
    </div>
  </div>
);

EntryWithRosterReadOnly.propTypes = {
  teamName: PropTypes.string,
  state: PropTypes.string,
  country: PropTypes.string,
  rosterPositions: PropTypes.arrayOf(PropTypes.object),
  pairCode: PropTypes.number,
  groupCode: PropTypes.string
};

EntryWithRosterReadOnly.defaultProps = {
  rosterPositions: []
};

export default EntryWithRosterReadOnly;



// WEBPACK FOOTER //
// ./src/features/shared/EntryWithRosterReadOnly.jsx